export const ONBOARDING_STEP_KEY = 'onboarding_step';
export const ID_VERIFICATION_KEY = 'id_verifying';
